import { Injectable } from '@angular/core';
import { IPSAuthenticationService } from '@ips/common-angular';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  constructor(private readonly authz: IPSAuthenticationService) {}

  getAvailableTenants(): Observable<string[]> {
    return this.authz.currentUser.pipe(
      map((user) => {
        const availableTenants = user.availableTenants.map(name => this.formatTenantName(name));
        
        if (availableTenants.length > 0) {
          localStorage.setItem('selectedTenant', availableTenants[0]);
        }

        return availableTenants;
      })
    );
  }

  formatTenantName(tenantName: string): string {
    if (!tenantName) {
      return '';
    }
    const words = tenantName.toLowerCase().split(' ');
    const formattedWords = words.map(word => {
      if (word.length <= 2 && word.length > 0) {
        return word.toUpperCase();
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
    });

    return formattedWords.join(' ');
  }
}
